import FormAddPO             from '@/components/FormAddPO'
import FormAddTO             from '@/components/FormAddTO'
import FormAddMO             from '@/components/FormAddMO'
import FormAddSO             from '@/components/FormAddSO'
import Dashboard             from '@/components/Dashboard'
import Login                 from '@/components/Login'
import NotFound              from '@/components/NotFound'
// import SeekOrigin            from '@/components/SeekOrigin'
import CheckFormula          from '@/components/CheckFormula'
import Container             from '@/components/Container'
import ShiftUser             from '@/components/ShiftUser'
import FormAddInventoryCover from '@/components/FormAddInventoryCover'
import Suppliment            from '@/components/Suppliment'
import ListOrders            from '@/components/ListOrders'
import ChangeView            from '@/components/ChangeView'
import ContainerMoving       from '@/components/FormContainerMoving'
import WasteOut              from '@/components/WasteOut'

export default [
    {
        path: '/',
        name: 'Dashboard',
        title: 'dashboard',
        icon: 'home',
        component: Dashboard,
        showInMenu: true,
        showInDashboard: false,
    },
    {
        path: '/purchase-orders',
        name: 'FormAddPO',
        title: 'purchaseOrders',
        icon: 'list',
        permission: 'purchase_order_management',
        component: FormAddPO,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/transfer-orders',
        name: 'FormAddTO',
        title: 'transferOrders',
        icon: 'graph_square',
        permission: 'transfer_order_management',
        component: FormAddTO,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/waste-outs',
        name: 'WasteOut',
        title: 'wasteOutOrders',
        icon: 'trash',
        permission: 'waste_out_view',
        component: WasteOut,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/container-moving',
        name: 'ContainerMoving',
        title: 'containerMoving',
        icon: 'graph_square',
        permission: 'container_moving',
        component: ContainerMoving,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/manufacture-orders',
        name: 'FormAddMO',
        title: 'mosManagement',
        icon: 'layers_alt',
        permission: 'mos_management',
        component: FormAddMO,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/sale-orders',
        name: 'FormAddSO',
        title: 'saleOrder',
        icon: 'document_text',
        permission: 'sos_management',
        component: FormAddSO,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/list-orders',
        name: 'ListOrders',
        title: 'listOrders',
        icon: 'document_text',
        permission: 'view_list_sos',
        component: ListOrders,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/inventory-covers',
        name: 'FormAddInventoryCover',
        title: 'transferCovers',
        icon: 'box',
        permission: 'inventory_covers_management',
        component: FormAddInventoryCover,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/suppliment',
        name: 'Suppliment',
        title: 'supplimentOrder',
        icon: 'tickets',
        permission: 'transfer_order_management',
        component: Suppliment,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/check-formula',
        name: 'CheckFormula',
        title: 'checkFormula',
        icon: 'bars_chart_square',
        permission: 'formula_management',
        component: CheckFormula,
        showInMenu: true,
        showInDashboard: true,
    },
    /*{
        path: '/seek-origin',
        name: 'SeekOrigin',
        title: 'seekOrigin',
        icon: 'qrcode',
        component: SeekOrigin,
        showInMenu: true,
        showInDashboard: true,
    },*/
    {
        path: '/shift-users',
        name: 'ShiftUser',
        title: 'ShiftUsers',
        icon: 'time',
        permission: 'shiftUsers_management',
        component: ShiftUser,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/containers',
        name: 'Container',
        title: 'inventory',
        icon: 'drawers',
        permission: 'container_management',
        component: Container,
        showInMenu: true,
        showInDashboard: true,
    },
    {
        path: '/change-views',
        name: 'ChangeView',
        title: 'changeview',
        icon: 'info',
        component: ChangeView,
        showInMenu: false,
        showInDashboard: false,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        showInMenu: false,
        showInDashboard: false,
    },
    {
        path: '(.*)',
        name: 'not-found',
        component: NotFound,
        showInMenu: false,
        showInDashboard: false,
    },
]
